import { required, minLength, validEmail } from 'services/validators'

export const vipContactForm = values => {
  const errors = {}
  if (!required(values.email)) {
    errors.email = 'Email requerido'
  } else if (!validEmail(values.email)) {
    errors.email = 'Email inválido'
  }
  if (!required(values.fullName)) {
    errors.fullName = 'Nombre requerido'
  }
  if (!required(values.telephone)) {
    errors.telephone = 'Teléfono requerido'
  }
  if (!required(values.message)) {
    errors.message = 'Mensaje requerido'
  }
  return errors
}
